export const PdfSignatureAction = "pdf.signature";
